import React from "react";
import Utstillingsresultater from "./Utstillingsresultater";
import TabLabel from "./TabLabel";
import UtenlandskeResultater from "./UtenlandskeResultater";
import ProeveResultater from "./ProeveResultater";
import ElementHelp from './ElementHelp';
import {withRouter, useHistory } from "react-router-dom";
import qs from "query-string";


const Utstillinger = (props) => {
    const {hund, utstillingsresultater, utenlandskeResultater, eksterioerGodkjennelseResultater} = props;
    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let tabId = 'udstilling';
    if (parsed.utstTab !== undefined) {
        tabId = parsed.utstTab;
    }


    const show = (t) => {
        if (tabId === t) {
            return true;
        }
        return false;

    };

    const renderTabTitelClass = (t) => {
        if (tabId === t) {
            return "tabs-title tab-active";
        }
        return "tabs-title";
    };


    const setTabId = (t) => {
        let params = parsed
        if (t !== tabId) {
            params.utstTab = t;
        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));

    };




    return (
        <div className="dogweb-box">
            <div className="dogweb-card-header">
                <div className="card-title">UDSTILLINGSRESULTATER </div>
                <div className="name-active-dog"> {hund.navn}</div>
                <ElementHelp slug={'udstilling'}/>
            </div>
            <div className="tab-container">
                <ul className="tabs" id="udstillingsresultater">
                    <li className={renderTabTitelClass('udstilling')}>
                        <button onClick={() => setTabId("udstilling")} >
                            <TabLabel name="UDSTILLING" count={utstillingsresultater && utstillingsresultater.length} />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('utenlandske')}>
                        <button onClick={() => setTabId("utenlandske")} >
                            <TabLabel name="UDENLANDSKE" count={utenlandskeResultater.length} />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('eksterioer')}>
                        <button onClick={() => setTabId("eksterioer")} >
                            <TabLabel name="EKSTERIØR" count={eksterioerGodkjennelseResultater.length} />
                        </button>
                    </li>
                </ul>
                <div className="tabs-panel is-active" >

                    {
                        show('udstilling') &&
                            <Utstillingsresultater resultater={utstillingsresultater} />
                    }
                    {
                        show('utenlandske') &&
                            <UtenlandskeResultater resultater={utenlandskeResultater} className="dogweb-utstilling" />
                    }

                    {
                        show('eksterioer') &&
                            <ProeveResultater resultater={eksterioerGodkjennelseResultater} />
                    }
                </div>
                <div className="dogweb-card-footer">
                </div>
            </div>

        </div>
    );

};

export default withRouter (Utstillinger);
